// MSMEYBBulletin.js
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import 'react-datepicker/dist/react-datepicker.css';
import Loader from '../../components/utils/Loader';
import DatePicker from 'react-datepicker';

const MSMEYBBulletin = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [cafeBulletin, setMSMEYBBulletin] = useState([]);
  const [bulletinLang, setBulletinLang] = useState('English');
  const [bulletinDate, setBulletinDate] = useState(new Date());
  const [fetchData, { loading }] = useFetch();

  const bulletinLangList = [
      'English',
      'French',
      'German',
      'Gujarati',
      'Hindi',
      'Italian',
      'Marathi',
      'Spanish',
  ];

  useEffect(() => {
    document.title = authState.isLoggedIn ? `${authState.user.name}'s MSMEYB` : "Think5Whys";
  }, [authState]);

  const fetchMSMEYBBulletin = useCallback(() => {
    const searchDate = bulletinDate;
    searchDate.setHours(0, 0, 0, 0);
    const localDate = new Date(searchDate.getTime() - (searchDate.getTimezoneOffset() * 60000));
    const formattedDate = localDate.toISOString().split('T')[0];

    const config = {
      url: "/cafebulletin/bydateandlang",
      method: "post",
      headers: { Authorization: authState.token },
      data: { bulletinDate: formattedDate, bulletinLang: bulletinLang }
    };
    
    // console.log("Bulletin Payload: ", config);
  
    fetchData(config, { showSuccessToast: false })
      .then(data => {
        if (Array.isArray(data.bulletinList)) {
          setMSMEYBBulletin(data.bulletinList);
        } else {
          setMSMEYBBulletin([]); 
        }
      });
  }, [authState.token, fetchData, bulletinDate, bulletinLang]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchMSMEYBBulletin();
  }, [authState.isLoggedIn, fetchMSMEYBBulletin]);

  const formatDate = (date) => {
    const options = {
      year: 'numeric', month: '2-digit', day: '2-digit',
    };
    return new Date(date).toLocaleString('en-IN', options);
  };

  const sortedMSMEYBBulletin = [...cafeBulletin].sort((a, b) => b.headline.localeCompare(a.headline));

  return (
    <div className='bg-black'>
      <div className="py-2 bg-gradient-to-r from-gray-600 via-gray-700 to-black">
        <h2 className='text-xl font-bold text-white text-center mb-2'>MSME Bulletin</h2>

        <div className="flex flex-col mb-4 border-2 border-yellow-300 p-4 rounded-lg shadow-lg">
          {/* <h2 className="text-xl font-semibold text-center text-white mb-4">MSMEYB Bulletin Search</h2> */}

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div className="flex flex-col">
              <label htmlFor="language" className="text-white font-medium mb-1">Select Language</label>
              <select
                id="language"
                value={bulletinLang}
                onChange={(e) => setBulletinLang(e.target.value)}
                className="mt-2 p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ height: "48px" }}
              >
                {bulletinLangList.map((lang) => (
                  <option key={lang} value={lang}>{lang}</option>
                ))}
              </select>
            </div>

            <div className="flex flex-col">
              <label htmlFor="date" className="text-white font-medium mb-1">Bulletin Date</label>
              <DatePicker
                selected={bulletinDate}
                onChange={(date) => setBulletinDate(date)}
                className="text-sm mt-2 p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ width: "350px", height: "48px"}}
                dateFormat="dd-MM-yyyy"
              />
            </div>
            <button
              onClick={fetchMSMEYBBulletin}
              className="bg-blue-500 text-white px-6 py-3 rounded-full hover:bg-blue-600 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Get Bulletin
            </button>
          </div>
        </div>

        <div className="mt-4 text-yellow-200">{formatDate(bulletinDate)} MSME Bulletin in {bulletinLang}</div>

        <div className="border border-gray-300 p-4 mt-4">
          <div className="mt-2">
            {cafeBulletin && cafeBulletin.length !== 0 && (
              sortedMSMEYBBulletin.map((bulletin) => (
                <div key={bulletin._id} className='bg-gray-600 my-1 p-1 text-white rounded-md shadow-md text-sm'>
                  <div className='flex flex-col border-2 border-orange-500 py-2 px-4'>
                  <p className='font-medium text-yellow-200'>{bulletin.headline} </p>
                    <p
                      className="text-white"
                      dangerouslySetInnerHTML={{ __html: bulletin.brief }}
                    ></p>
                    <p className='text-green-500'>Author: {bulletin.authorName}</p>
                    <p className='text-green-500'>Source: {bulletin.bulletinSource}</p>

                  </div>
                </div>
              ))
            )}
          </div>

          {loading ? (
            <Loader />
          ) : (
            <div>
              {cafeBulletin && cafeBulletin.length === 0 && (
                <div className='min-h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                  <div className="flex justify-between items-center">
                    <h3 className='text-lg mt-1 mx-2 text-orange-400'>Bulletin Not Found!</h3>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>      
    </div>
  );
}

export default MSMEYBBulletin;
